@if (transaction(); as transaction) {
  <div class="bg-[#F2F4F5] pt-[32px] pb-[10px] -mx-4 px-4 rounded-b-[10px]">
    <img class="mb-3 mx-auto" ngSrc="assets/icons/icon-out-transaction.svg" alt="out-transaction" height="55"
         width="55">
    <h2 class="text-[20px] !font-bold !mb-8 text-center">
      Outgoing Transaction Report
    </h2>
    <div class="px-[11px] mb-1">
      <p
        class="flex justify-between items-center min-h-[24px] !mb-0 text-[12px] border-t border-solid border-[#022D35] border-opacity-10">
        <span>ID</span>
        <span>{{ transaction.id }}</span>
      </p>
      <p
        class="flex justify-between items-center min-h-[24px] !mb-0 text-[12px] border-t border-solid border-[#022D35] border-opacity-10">
        <span>Report Time</span>
        <span>{{ transaction.timeCreated | date: 'h:mm a, dd/MM/yy' }}</span>
      </p>
    </div>

    <div class="bg-white flex flex-col rounded-[8px] shadow-3 border border-solid border-[#022D35] mb-[9px]">
      <div class="rounded-[6px] py-[9px] px-[11px] flex items-center"
           [ngClass]="stateDetailsTransaction() ? 'bg-[#F2F4F5]' : 'bg-white'">
        <img class="w-[30px] h-[30px] mr-[7px]"
             [src]="'assets/icons/currency/' + (transaction.coin | lowercase) + '.svg'" alt="">
        <div class="min-w-[38px] flex flex-col mr-3 relative"
             [ngClass]="{'after:absolute after:-right-[6px] after:-top-[9px] after:-bottom-[9px] after:bg-[#022D35] after:w-[1px]': !stateDetailsTransaction()}"
        >
          <span class="leading-[1.2] text-[14px] font-bold mb-1">{{ transaction.coin }}</span>
          <span class="text-[11px] leading-[1.2] ">{{ transaction.network | convertNetworkToToken }}</span>
        </div>
        <div class="flex flex-col mr-3">
          <span class="text-[12px] leading-[1.2] mb-1 mt-[1px]"
                [ngClass]="{'text-[#94A3A6]': !stateDetailsTransaction()}">Receiver:</span>
          <span class="flex items-center pt-[1px]">
            <span class="mr-1 leading-[1] text-[14px]"
                  [ngClass]="!stateDetailsTransaction() ? 'opacity-40' : 'text-[#7A9095]'">
              @if ((!stateDetailsTransaction() && currentLang === 'ru')) {
                {{ transaction.addressTo | cropWithDotsCenter: 5 : 5 }}
              } @else {
                {{ transaction.addressTo | cropWithDotsCenter: 7 : 7 }}
              }
            </span>
            <app-copy-button [currentColor]="'text-[#7A9095] opacity-50'" [value]="transaction.addressTo"
                             [size]="'small'"></app-copy-button>
          </span>
        </div>

        <button (click)="toggleDetailsTransaction()" type="button"
                class="font-medium text-[#022D35] flex justify-center items-center border border-solid border-[#022D35] rounded-[4px] min-h-[29px] px-2 ml-auto"
                mat-raised-button mat-button color="primary">
          {{ (stateDetailsTransaction() ? 'Close' : 'Details') }}
        </button>
      </div>
      @if (stateDetailsTransaction()) {
        <div class="flex justify-start py-3 pr-3 pl-4">
          <img class="mr-[15px]" ngSrc="assets/icons/arrow-up-new.svg" alt="arrow" height="78" width="18">
          <div class="flex flex-col">
            <span class="text-[12px] leading-[1.2]">Amount Received:</span>
            <span class="leading-[1.2] text-[26px] tracking-[-0.45px] font-medium mb-2">
              @switch (transaction.coin) {
                @case ('USDT') {
                  {{ (transaction.amount | cutNumber:('1.2-2')) ?? '0.00' }}
                }
                @default {
                  {{ (transaction.amount | cutNumber:('1.2-8')) ?? '0.00' }}
                }
              }
              {{ transaction.coin }}</span>
            <span class="text-[#7A9095] text-[12px] leading-[1.2] mb-[2px]">Hash:</span>
            <span class="flex items-center">
              <span
                class="text-[#7A9095] text-[14px] leading-[1]">{{ transaction.target | cropWithDotsCenter:14:14 }}</span>
              <app-copy-button [currentColor]="'text-[#7A9095] opacity-50'" class="ml-1" [value]="transaction.target"
                               [size]="'small'"></app-copy-button>
            </span>
          </div>
        </div>
        <div class="bg-[#F2F4F5] rounded-[6px] py-[9px] px-[11px] flex items-center">
          <img class="w-[30px] h-[30px] mr-[7px]"
               [src]="'assets/icons/currency/' + (transaction.coin | lowercase) + '.svg'" alt="">
          <div class="min-w-[38px] flex flex-col mr-3">
            <span class="leading-[1.2] text-[14px] font-bold mb-1">{{ transaction.coin }}</span>
            <span class="text-[11px] leading-[1.2] ">{{ transaction.network | convertNetworkToToken }}</span>
          </div>
          <div class="flex flex-col mr-3">
            <span class="flex text-[12px] leading-[1.2] mb-1 mt-[1px]">
              <span class="mr-3">Sender:</span>
              @if (transaction.type === 'OUTCOMING') {
                <span class="font-bold">My wallet: {{ transaction.walletName }}</span>
              }
            </span>
            <span class="flex items-center pt-[1px]">
              <span
                class="text-[#7A9095] leading-[1] text-[14px] mr-1">{{ transaction.addressFrom | cropWithDotsCenter:12:12 }}</span>
              <app-copy-button [currentColor]="'text-[#7A9095] opacity-50'" [value]="transaction.addressFrom"
                               [size]="'small'"></app-copy-button>
            </span>
          </div>
        </div>
      }
    </div>
    <a target="_blank" href="https://t.me/AMLOfficer_support_bot"
       class="flex justify-between items-center rounded-[6px] min-h-[25px] px-3 py-1 mb-3"
       [ngClass]="{'text-white': transaction.riskScore !== 'MEDIUM'}"
       [class.bg-[#C92F29]]="transaction.riskScore === 'SEVERE'"
       [class.bg-[#EA3D3D]]="transaction.riskScore === 'HIGH'"
       [class.bg-[#FFCB10]]="transaction.riskScore === 'MEDIUM'"
       [class.bg-[#87C05A]]="transaction.riskScore === 'LOW'"
    >
      <div class="flex items-center">
        <div class="mr-[10px]">
          @switch (transaction.riskScore) {
            @case ('SEVERE') {
              <img [ngSrc]="'assets/icons/icon-risk-severe.svg'" alt="risk" height="14" width="14">
            }
            @case ('HIGH') {
              <img [ngSrc]="'assets/icons/icon-risk-high.svg'" alt="risk" height="14" width="6">
            }
            @case ('MEDIUM') {
              <img [ngSrc]="'assets/icons/icon-risk-medium.svg'" alt="risk" height="14" width="6">
            }
            @case ('LOW') {
              <img [ngSrc]="'assets/icons/icon-risk-low.svg'" alt="risk" height="12" width="12">
            }
          }
        </div>
        <span class="leading-[1.2] text-[13px]">
          @switch (transaction.riskScore) {
            @case ('SEVERE') {
              Severe Risk Level
            }
            @case ('HIGH') {
              High Risk Level
            }
            @case ('MEDIUM') {
              Medium Risk Level
            }
            @case ('LOW') {
              Low Risk Level
            }
          }
        </span>
      </div>
      <div class="flex">
        <span class="leading-[1.2] text-[11px]">
          Ask Compliance →
        </span>
      </div>
    </a>
    @if ((transaction.type === 'OUTCOMING' || transaction.type === 'WALLET_SCAN') && asOutgoingTransaction(transaction); as
      outgoingTransaction) {
      @if (transaction.latestAmlReport && outgoingTransaction.latestAmlReport.riskReason) {
        <div class="flex flex-col p-2 border border-solid border-[#022D35] rounded-[6px]">
          <span class="mb-1">Risk reason:</span>
          <span
            class="text-[#45525B] opacity-50 leading-[1.3]">{{ outgoingTransaction.latestAmlReport.riskReason }}</span>
        </div>
      }
    }
  </div>

  @if ((transaction.type === 'OUTCOMING' || transaction.type === 'WALLET_SCAN') && asOutgoingTransaction(transaction); as
    outgoingTransaction) {
    @if (outgoingTransaction.latestAmlReport; as riskResponse) {
      <div class="mt-3">
        <mat-tab-group class="report-tabs" animationDuration="0ms">
          @if (riskResponse.exposures && riskResponse.exposures.length > 0) {
            <mat-tab [label]="('Sources') + ' (' + riskResponse.exposures.length + ')'">
              <app-report-exposures class="block mt-3" [exposures]="riskResponse.exposures"
                                    [typeReport]="'OUTCOMING_TRANSACTION'"></app-report-exposures>
            </mat-tab>
          }
          @if (riskResponse.triggers && riskResponse.triggers.length > 0) {
            <mat-tab [label]="('Triggers') + ' (' + riskResponse.triggers.length + ')'">
              <app-report-triggers class="block mt-3" [riskResponse]="riskResponse"
                                   [typeReport]="'OUTCOMING_TRANSACTION'"></app-report-triggers>
            </mat-tab>
          }
          @if (riskResponse.cluster || (riskResponse.addressIdentifications && riskResponse.addressIdentifications.length > 0)) {
            <mat-tab [label]="'Important'">
              @if (riskResponse.cluster && riskResponse.addressIdentifications && riskResponse.addressIdentifications.length > 0) {
                <app-report-identification class="block mt-3" [typeReport]="'OUTCOMING_TRANSACTION'"
                                           [info]="{name: riskResponse.cluster.name, category: riskResponse.cluster.category, description: riskResponse.addressIdentifications[0].description}"></app-report-identification>
              } @else if (riskResponse.cluster) {
                <app-report-identification class="block mt-3" [typeReport]="'OUTCOMING_TRANSACTION'"
                                           [info]="{name: riskResponse.cluster.name, category: riskResponse.cluster.category, description: ''}"></app-report-identification>
              } @else {
                @if (riskResponse.addressIdentifications; as addressIdentifications) {
                  @if (addressIdentifications.length > 0) {
                    <app-report-identification class="block mt-3" [typeReport]="'OUTCOMING_TRANSACTION'"
                                               [info]="{name: addressIdentifications[0].name, category: addressIdentifications[0].category, description: addressIdentifications[0].description}"></app-report-identification>
                  }
                }
              }
            </mat-tab>
          }
        </mat-tab-group>
      </div>
    }
  }
}
